/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/utils/industryUseCaseUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { create } from 'zustand';
import { readUnhandledEnumCase } from 'rpc-client-utils';
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/utils/industryUseCaseUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const IndustryUseCaseDefaultState = {
  LESSON: {},
  SHORT_FORM_CONTENT: {},
  TRACK: {}
};
const getIndustryCacheKey = industry => {
  if (!industry) return undefined;
  return readUnhandledEnumCase(industry);
};
const getSessionEntry = (state, contentType, contentId) => {
  var _state$contentType$co;
  return (_state$contentType$co = state[contentType][contentId]) !== null && _state$contentType$co !== void 0 ? _state$contentType$co : {
    byIndustry: {}
  };
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/utils/industryUseCaseUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useUseCaseSessionConfig = create(set => Object.assign({}, IndustryUseCaseDefaultState, {
  setUseCaseTaskId: ({
    contentType,
    contentId,
    taskId,
    industry
  }) => {
    const industryKey = getIndustryCacheKey(industry);
    if (!industryKey) return;
    set(state => {
      var _session$byIndustry$i;
      const session = getSessionEntry(state, contentType, contentId);
      const existingEntry = (_session$byIndustry$i = session.byIndustry[industryKey]) !== null && _session$byIndustry$i !== void 0 ? _session$byIndustry$i : {};
      return {
        [contentType]: Object.assign({}, state[contentType], {
          [contentId]: {
            byIndustry: Object.assign({}, session.byIndustry, {
              [industryKey]: Object.assign({}, existingEntry, {
                taskId
              })
            })
          }
        })
      };
    });
  },
  setUseCaseData: ({
    contentType,
    contentId,
    useCase,
    correlationId,
    industry
  }) => {
    const industryKey = getIndustryCacheKey(industry);
    if (!industryKey) return;
    set(state => {
      var _session$byIndustry$i2;
      const session = getSessionEntry(state, contentType, contentId);
      const existingEntry = (_session$byIndustry$i2 = session.byIndustry[industryKey]) !== null && _session$byIndustry$i2 !== void 0 ? _session$byIndustry$i2 : {};
      return {
        [contentType]: Object.assign({}, state[contentType], {
          [contentId]: {
            byIndustry: Object.assign({}, session.byIndustry, {
              [industryKey]: Object.assign({}, existingEntry, {
                useCase,
                correlationId
              })
            })
          }
        })
      };
    });
  }
}));

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/utils/industryUseCaseUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useUseCaseSession = () => {
  const {
    LESSON,
    SHORT_FORM_CONTENT,
    TRACK,
    setUseCaseTaskId,
    setUseCaseData
  } = useUseCaseSessionConfig();
  const getUseCaseState = (id, contentType) => {
    switch (contentType) {
      case 'LESSON':
        return LESSON[id];
      case 'SHORT_FORM_CONTENT':
        return SHORT_FORM_CONTENT[id];
      case 'TRACK':
        return TRACK[id];
      default:
        return undefined;
    }
  };
  const getUseCaseForIndustry = (id, contentType, industry) => {
    var _getUseCaseState;
    const industryKey = getIndustryCacheKey(industry);
    if (!industryKey) return undefined;
    return (_getUseCaseState = getUseCaseState(id, contentType)) === null || _getUseCaseState === void 0 || (_getUseCaseState = _getUseCaseState.byIndustry) === null || _getUseCaseState === void 0 ? void 0 : _getUseCaseState[industryKey];
  };
  return {
    getUseCaseForIndustry,
    getUseCaseState,
    setUseCaseTaskId,
    setUseCaseData
  };
};